import type { MailboxConnection } from "@sales-ops-amplify/shared";
import { apiDelete, apiGet, apiPatch, apiPost } from "./client";

export function listMailboxes(): Promise<{
  mailboxes: MailboxConnection[];
  hasGmailSend: boolean;
  hasOutlook: boolean;
  needsReconsent: boolean;
  googleConfigured?: boolean;
  microsoftConfigured?: boolean;
}> {
  return apiGet("/api/mailboxes");
}

export function refreshMailboxes(): Promise<{
  mailboxes: MailboxConnection[];
  hasGmailSend: boolean;
  hasOutlook: boolean;
  needsReconsent: boolean;
}> {
  return apiPost("/api/mailboxes/refresh", {});
}

export function setPrimaryMailbox(
  mailboxId: string,
): Promise<{ mailbox: MailboxConnection }> {
  return apiPost(`/api/mailboxes/${mailboxId}/primary`, {});
}

export function updateMailboxLimits(
  mailboxId: string,
  fields: {
    dailySendLimit?: number;
    hourlySendLimit?: number;
    delayBetweenEmailsSec?: number;
  },
): Promise<{ mailbox: MailboxConnection }> {
  return apiPatch(`/api/mailboxes/${mailboxId}/limits`, fields);
}

export function disconnectMailbox(
  mailboxId: string,
): Promise<{ connected: boolean }> {
  return apiDelete(`/api/mailboxes/${mailboxId}`);
}

export function startMicrosoftOAuth(): Promise<{
  url: string;
  configured?: boolean;
}> {
  return apiGet("/api/mailboxes/microsoft/oauth/start");
}
